import { Author } from "./Author";
import { Category } from "./Category";
import map from "lodash/fp/map";
import { nameAndIdToUrl } from "../utils/slug";
import getOr from 'lodash/fp/getOr';
import { LocalStorage } from "./LocalStorage";

export class Blog {
  constructor(id, title, slug, excerpt, bannerUrl, metaTitle, metaDescription, staff, categories, tags, content, publishAt, createdAt, updatedAt, locale) {
    this.id = id;
    this.title = title;
    this.slug = slug;
    this.excerpt = excerpt;
    this.bannerUrl = bannerUrl;
    this.metaTitle = metaTitle;
    this.metaDescription = metaDescription;
    this.staff = staff;
    this.categories = categories;
    this.tags = tags || [];
    this.content = content;
    this.publishAt = publishAt;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.locale = locale || "";
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new Blog(
        input[this.BLOG_ATTRIBUTE.ID],
        input[this.BLOG_ATTRIBUTE.TITLE],
        input[this.BLOG_ATTRIBUTE.SLUG],
        input[this.BLOG_ATTRIBUTE.EXCERPT],
        getOr("", "url")(input[this.BLOG_ATTRIBUTE.BANNER]),
        input[this.BLOG_ATTRIBUTE.META_TITLE],
        input[this.BLOG_ATTRIBUTE.META_DESCRIPTION],
        Author.fromApiObject(input[this.BLOG_ATTRIBUTE.STAFF]),
        Category.fromApiArray(input[this.BLOG_ATTRIBUTE.CATEGORIES]),
        input[this.BLOG_ATTRIBUTE.TAGS],
        input[this.BLOG_ATTRIBUTE.CONTENT],
        input[this.BLOG_ATTRIBUTE.PUBLISH_AT],
        input[this.BLOG_ATTRIBUTE.CREATED_AT],
        input[this.BLOG_ATTRIBUTE.UPDATED_AT],
        input[this.BLOG_ATTRIBUTE.LOCALE],
      )
    }

    return new Blog();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => Blog.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [Blog.fromApiObject(input)];
    }

    return [];
  }

  static BLOG_ATTRIBUTE = {
    ID: "id",
    TITLE: "title",
    SLUG: "slug",
    EXCERPT: "excerpt",
    BANNER: "banner",
    BANNER_URL: "banner_url",
    META_TITLE: "meta_title",
    META_DESCRIPTION: "meta_description",
    STAFF: "staff",
    CATEGORIES: "categories",
    TAGS: "tags",
    CONTENT: "content",
    PUBLISH_AT: "publish_at",
    CREATED_AT: "created_at",
    UPDATED_AT: "updated_at",
    LOCALE: "locale",
  }

  genBox(rootDetail = "", slug = "b", doFollow = false) {
    const follow = doFollow ? "dofollow" : "nofollow";
    let date = this.publishAt ? window.moment(this.publishAt * 1000).format(LocalStorage.getLanguage() === "vi" ? "DD/MM/YYYY" : "MMMM D, YYYY") : "";
    const html = `
      <div class="blog-item item">
        <div class="border-box">
          <a ref="${follow}" class="banner" href="${rootDetail}/${nameAndIdToUrl(this.id, this.slug || this.title, slug)}">
            <div style="background-image: url(${this.bannerUrl}?max-w=1000)"></div>
          </a>
          <div class="content">
            <a ref="${follow}" class="title" href="${rootDetail}/${nameAndIdToUrl(this.id, this.slug || this.title, slug)}">
              <h2 title="${this.title}">${this.title}</h2>
            </a>
            <div class="description">${this.excerpt}</div>
            <div class="bottom-box">
              <div class="category">${map("link")(this.categories).join(", ")}</div>
              <div class="date">${date}</div>
              <a ref="${follow}" class="readmore" href="${rootDetail}/${nameAndIdToUrl(this.id, this.slug || this.title, slug)}">
                <div data-i18n="blogs_readmore">${$.i18n("blogs_readmore")}</div>
              </a>
            </div>
          </div>
        </div>
      </div>
    `;
    return html;
  }
}